module.exports = __webpack_public_path__ + "static/media/bip.aa440353.mp3";